export default {
  // Estado del loader
  // Inicialmente mostramos el loader
  // luego de que carga la primera vista
  // lo quitamos
  isLoading: false,
  tipoError: null,
  tcode: "",
  notificationToast: {
    // [info, success, alert]
    type: "",
    message: ""
  },
  paso1: {
    captcha: "",
    numCliente: "",
    criterioConsulta: "",
    nroDocumento: "",
    tipoDoc: "00"
  },
  paso2: {
    numeroCliente: "",
    campanias: [
      {
        idCamp: "",
        tipoCampania: ""
      }
    ]
  },
  paso3: {
    seleccion: "",
    numeroCampania: "",
    campaniaSeleccionada: "",
    numeroCliente: "",
    numeroSegmento: "",
    premios: [
      {
        codigoPremio: "",
        tipoPremio: "",
        descripcionPremio: ""
      }
    ]
  },
  paso4: {
    hash: "",
    url: ""
  },
  tipoCampaniaSeleccionada: "",
  userIdTokenizado: null
};
